import React from "react";
import { Link } from "react-router-dom";
import { CheckSquare, BookOpen, FileText, Sparkles, TrendingUp, GraduationCap, Zap, ChevronRight } from "lucide-react";

const CARDS = [
  { to: "/dashboard/agency/success/checklist", icon: CheckSquare, title: "Launch Checklist", desc: "Legally set up and launch your recruiting business, step by step.", color: "from-navy to-slate-800" },
  { to: "/dashboard/agency/success/growth", icon: TrendingUp, title: "Growth Dashboard", desc: "Track placements, revenue, commissions, KPIs, and set goals.", color: "from-amber-500 to-yellow-600" },
  { to: "/dashboard/agency/success/playbooks", icon: BookOpen, title: "Playbooks", desc: "10 step-by-step guides from client hunting to placement follow-up.", color: "from-slate-700 to-slate-900" },
  { to: "/dashboard/agency/success/templates", icon: FileText, title: "Resource Library", desc: "Editable agreements, emails, scripts, forms — ready to send.", color: "from-slate-700 to-slate-900" },
  { to: "/dashboard/agency/success/ai", icon: Sparkles, title: "AI Recruiting Toolkit", desc: "Boolean, email, LinkedIn, proposals, strategy — powered by Claude.", color: "from-amber-500 to-yellow-600" },
  { to: "/dashboard/agency/success/learning", icon: GraduationCap, title: "Learning Center", desc: "Deep-dive articles on recruiting skill, compliance, and business.", color: "from-slate-700 to-slate-900" },
  { to: "/dashboard/agency/success/automations", icon: Zap, title: "Automation Center", desc: "Turn on follow-ups, reminders, weekly digests, and more.", color: "from-navy to-slate-800" },
];

export default function SuccessHome() {
  return (
    <div>
      <div className="mb-8">
        <div className="eyebrow mb-2">Success Center</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-navy">Everything you need to run — and grow — your recruiting agency from home.</h1>
        <p className="text-slate-600 mt-3 max-w-2xl">Connecting Great People with Great Companies Through Technology, Expertise, and Personal Relationships.</p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {CARDS.map((c, i) => {
          const Icon = c.icon;
          return (
            <Link key={i} to={c.to} className="card-lift border border-slate-200 rounded-xl bg-white overflow-hidden group">
              <div className={`h-2 bg-gradient-to-r ${c.color}`} />
              <div className="p-5">
                <div className="h-11 w-11 rounded-lg bg-gold/10 text-gold grid place-items-center mb-3">
                  <Icon className="w-5 h-5" />
                </div>
                <div className="font-display text-lg font-semibold text-navy">{c.title}</div>
                <p className="text-sm text-slate-600 mt-1">{c.desc}</p>
                <div className="mt-4 text-sm font-medium text-navy inline-flex items-center gap-1 group-hover:text-gold transition-colors">
                  Open <ChevronRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
